"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var StateDomainObject_1 = require("../../core/model/StateDomainObject");
/**
 * Describes available and physical stock of {@link Product internal product} within single {@link InternalSite internal site}.
 *
 * @author RV
 * @author JMe
 */


var Supply =
/*#__PURE__*/
function (_StateDomainObject_1$) {
  _inherits(Supply, _StateDomainObject_1$);

  /**
   * @param id internal id of entity
   * @param externalId external id of entity
   * @param productId internal id of internal product
   * @param siteId internal id of internal site (we omit warehouses of type stock)
   * @param transactionId internal id of transaction
   * @param availableSupply available stock in internal site
   * @param physicalSupply physical stock in internal site
   * @param physicalSupplyValue price value of physical stock in default system currency
   * @param stateFlags
   */
  function Supply(id, externalId, productId, siteId, transactionId, availableSupply, physicalSupply, physicalSupplyValue, stateFlags) {
    var _this;

    _classCallCheck(this, Supply);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Supply).call(this, stateFlags));
    _this.id = id;
    _this.externalId = externalId;
    _this.productId = productId;
    _this.siteId = siteId;
    _this.transactionId = transactionId;
    _this.availableSupply = availableSupply;
    _this.physicalSupply = physicalSupply;
    _this.physicalSupplyValue = physicalSupplyValue;
    _this.stateFlags = stateFlags;
    return _this;
  }

  return Supply;
}(StateDomainObject_1.StateDomainObject);

exports.Supply = Supply;

Supply.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(Supply.name);
  return {
    id: builder.id('id'),
    externalId: builder.id('externalId'),
    productId: builder.id('productId'),
    siteId: builder.id('siteId'),
    transactionId: builder.opt(builder.id('transactionId')),
    availableSupply: builder.data('availableSupply', {
      value: builder.bigNum('value'),
      unitId: builder.str('unitId')
    }),
    physicalSupply: builder.data('physicalSupply', {
      value: builder.bigNum('value'),
      unitId: builder.str('unitId')
    }),
    physicalSupplyValue: builder.bigNum('physicalSupplyValue'),
    stateFlags: builder.flags('stateFlags', EntityStateFlag_1.EntityStateFlag)
  };
}();